export const chevronUpIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>`;
export const chevronDownIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>`;
export const plusIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>`;
export const minusIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>`;
export const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;

export const getAccordionPrimaryIconSvg = (type, open) => {
  switch (type) {
    case 'chevron-down-up':
      return open ? chevronUpIconSvg : chevronDownIconSvg;
    case 'plus-minus':
      return open ? minusIconSvg : plusIconSvg;
    case 'plus-close':
      return open ? closeIconSvg : plusIconSvg;
    default:
      return open ? minusIconSvg : plusIconSvg;
  }
};

const defaultProperties = {
  open: true,
  title: '<h2><strong>Accordion Title</strong></h2>',
  backgroundColor: '#000000',
  color: '#ffffff',
  icon: {
    type: 'plus-minus', // chevron-down-up, plus-minus, plus-close
    position: 'right', // left, right
    show: true,
  },
};

export default (contentHtml, properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  return `
    <div
      data-attribute="accordion-primary-title"
      class="accordion-primary-title"
      data-open="${finalProperties.open ? 'true' : 'false'}"
      data-background="${finalProperties.backgroundColor}"
      data-color="${finalProperties.color}"
      data-icon-type="${finalProperties.icon.type}"
      data-icon-position="${finalProperties.icon.position}"
      data-icon-show="${finalProperties.icon.show ? 'true' : 'false'}"
      style="
        background-color: ${finalProperties.backgroundColor}; 
        color: ${finalProperties.color};
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: center;
        flex-direction: ${finalProperties.icon.position === 'left' ? 'row-reverse' : 'row'};
     "         
    >
      <div data-attribute="accordion-title" class="accordion-title">
        ${finalProperties.title}
      </div>
      <div
        data-attribute="accordion-icon"
        class="accordion-icon"
        style="display: flex; align-items: center"
      >
        ${getAccordionPrimaryIconSvg(finalProperties.icon.type, finalProperties.open)}
      </div>
    </div>

    <div data-attribute="accordion-primary-content" class="accordion-primary-content">
      ${contentHtml}
    </div>
    `.trim();
};
